export default {
  Model: 'Model',
  RequestReplacement: 'Request Replacement'
}